import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

const lookup = (payload: { searchText: string; }) => {
  const url = `${API_ENDPOINTS.lookupPlatforms}?${queryString.stringify({ search: payload.searchText || '' })}`;
  return http.get(url);
};

const PlatformService = { 
  lookup,
};

export default PlatformService;
